import Header from "./components/Header/Header";
import MainSection from "./components/MainSection/MainSection";
import Footer from "./components/Footer/Footer";

function CoolJob() {
  return (
    <>
      <Header />
      <MainSection />
      <Footer />
    </>
  );
}

export default CoolJob;

    
